/* ===== VISIQE × Rubik/Dawn – Variant Image Bridge =====
 * Macht die visiqe-thumbs Leiste:
 *  - variantenbewusst (zeigt nur Bilder der aktiven Variante)
 *  - klickbar (steuert das native Media-Gallery von Dawn)
 *  - scrollbar mit Pfeilen
 */

(function () {
  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

  const isMobile = () => matchMedia('(max-width: 749px)').matches;

  function currentVariantId(root=document){
    // Haupt-Variant-ID aus dem Add-to-Cart-Formular holen
    const inp = qs('form[action*="/cart/add"] input[name="id"]', root);
    return inp && inp.value ? String(inp.value) : null;
  }

  function findNativeThumb(mediaId, scope=document){
    // Versucht einen nativen Dawn-Thumb oder Media-Button zu finden
    return qs(
      `.product__media-wrapper [data-media-id="${mediaId}"]` +
      `, .thumbnail-list__item button[data-media-id="${mediaId}"]` +
      `, .thumbnail[aria-controls][data-target="${mediaId}"]`,
      scope
    );
  }

  function clickNative(mediaId, scope=document){
    const t = findNativeThumb(mediaId, scope);
    if (t) {
      t.click();
      return true;
    }
    // Fallback: Event an MediaGallery feuern (neuere Dawn-Versionen)
    try {
      window.dispatchEvent(
        new CustomEvent('mediaGallery:select', {
          detail: { mediaId: String(mediaId) }
        })
      );
      return true;
    } catch (e) {}
    return false;
  }

  function scrollByTrack(btn, dir){
    const track = btn && btn.closest('nav') && btn.closest('nav').querySelector('.vt-track');
    if(!track) return;
    const delta = Math.round(track.clientWidth * 0.8) * (dir === 'next' ? 1 : -1);
    track.scrollBy({ left: delta, behavior: 'smooth' });
  }

  // --- Sichtbar: nur Bilder der aktiven Variante ---
  function syncThumbsForVariant(nav){
    if(!nav || !isMobile()) return;

    const track = qs('.vt-track', nav);
    if(!track) return;

    const root = nav.closest('product-info') || document;
    const vid = currentVariantId(root) || (qs('select[name="id"]', root) && qs('select[name="id"]', root).value);
    if(!vid) return;

    const buttons = qsa('.visiqe-thumb', track);

    buttons.forEach(b => {
      const ids = (b.getAttribute('data-variant-ids') || '')
        .split(',')
        .map(x => x.trim())
        .filter(Boolean);

      // Wenn keine Zuordnung -> Bild für alle Varianten
      const show = ids.length === 0 ? true : ids.includes(String(vid));

      b.style.display = show ? '' : 'none';
      b.classList.remove('is-active');
    });

    // Featured-Bild der Variante nach vorne ziehen (falls vorhanden)
    const visibleButtons = buttons.filter(b => b.style.display !== 'none');
    const featured = visibleButtons.find(b => b.classList.contains('is-featured'));
    if (featured && featured.parentElement.firstElementChild !== featured) {
      track.insertBefore(featured, track.firstElementChild);
    }

    // Ersten sichtbaren Thumb aktiv markieren
    const first = visibleButtons[0];
    if(first){
      first.classList.add('is-active');
    }
  }

  function wireNav(nav){
    if(!nav || nav.__visiqe_wired) return;
    nav.__visiqe_wired = true;

    const root = nav.closest('product-info') || document;

    // Klick auf Thumb -> großes Bild wechseln
    nav.addEventListener('click', (e)=>{
      const btn = e.target.closest('.visiqe-thumb');
      if(!btn) return;

      const mediaId = btn.getAttribute('data-media-id');
      if(!mediaId) return;

      // active-Klasse setzen
      qsa('.visiqe-thumb', nav).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      clickNative(mediaId, root);
    });

    // Pfeile (Scroll)
    const prev = qs('.vt-prev', nav);
    const next = qs('.vt-next', nav);

    if(prev){
      prev.addEventListener('click', ()=>scrollByTrack(prev, 'prev'));
    }
    if(next){
      next.addEventListener('click', ()=>scrollByTrack(next, 'next'));
    }

    // initial sync
    syncThumbsForVariant(nav);
  }

  function initAll(context=document){
    const navs = qsa('.visiqe-thumbs', context);
    navs.forEach(wireNav);

    // Bei Variant-Wechsel neu synchronisieren
    // 1) Change auf Variant-Picker
    qsa('form[action*="/cart/add"] [name="id"]', context).forEach(inp => {
      inp.addEventListener('change', () => {
        navs.forEach(syncThumbsForVariant);
      });
    });

    // 2) Events vom Dawn-Script (MediaGallery / VariantChange)
    document.addEventListener('variant:changed', () => {
      navs.forEach(syncThumbsForVariant);
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  // Theme Editor – wenn Section neu geladen wird
  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });
})();
